// TODO
export const ZapReceiptEvent = () => {
  return (
    <>
      <span></span>
    </>
  )
}
